import type { PriceRankRoomItemInput } from "@/lib/gql/__generated__/graphql";

import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";
import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { RoomPriceRankBatchRoomPriceInput } from "../batch-room-price-input";

import type { RoomPriceRankItemType } from "../../../../../../type";

type Props = {
	accordionItemValue: string;

	priceRankItem: RoomPriceRankItemType;
	room: ForAutoGenerator<PriceRankRoomItemInput, "">;

	onSetPriceAmount: (roomID: string, amount: number | undefined, adultNum: number) => void;

	onSetRoomPriceRankItem: (value: RoomPriceRankItemType) => void;
};

export const RoomPriceRankRoomListItem = ({
	accordionItemValue,
	priceRankItem,
	room,
	onSetPriceAmount,
	onSetRoomPriceRankItem,
}: Props) => {
	const roomID = room.roomID.value;

	return (
		<AccordionItem value={accordionItemValue} className="mx-4">
			<AccordionTrigger className="text-left">
				<p className="flex-1 text-lg">{room.roomName.value}</p>
			</AccordionTrigger>
			<AccordionContent>
				<div className="ml-0 divide-y divide-zinc-100 laptop:ml-5">
					<RoomPriceRankBatchRoomPriceInput
						roomID={roomID}
						priceRankItem={priceRankItem}
						onSetRoomPriceRankItem={onSetRoomPriceRankItem}
					/>
					<div className="flex flex-col gap-y-4">
						{room.prices?.value?.map((item) => {
							return (
								<div
									className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-2 text-base laptop:gap-x-12"
									key={`${accordionItemValue}_${item.adultNum.value}`}
								>
									<div className="flex items-center gap-x-3 laptop:gap-x-6">
										<p className="shrink-0 text-sm tabular-nums laptop:text-base">
											大人 {item.adultNum.value} 人のとき１泊
										</p>
										<InputNumberField
											value={item.price.amount.value}
											errorMessage={item.price.amount.error}
											handleInput={(input) =>
												onSetPriceAmount(room.roomID.value, input, item.adultNum.value)
											}
										/>
									</div>
									<div>
										<p className="text-sm laptop:text-base">
											確認用：
											{item.price.amount.value?.toLocaleString()} 円
										</p>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</AccordionContent>
		</AccordionItem>
	);
};

RoomPriceRankRoomListItem.displayName = "RoomPriceRankRoomListItem";
